const e = "styles-module__booking_summary_container___oKnsK", o = "styles-module__booking_summary_container_expanded___vdmUe", _ = "styles-module__footer___TZfe3", n = "styles-module__disclaimer___e-thH", m = {
  booking_summary_container: e,
  booking_summary_container_expanded: o,
  "booking-summary-container": "styles-module__booking-summary-container___rW3mb",
  "booking-summary": "styles-module__booking-summary___M-yOC",
  footer: _,
  disclaimer: n,
  "booking-summary-container-opened": "styles-module__booking-summary-container-opened___fRUcl",
  "booking-summary-container-expanded": "styles-module__booking-summary-container-expanded___0e9FM",
  "cart-summary": "styles-module__cart-summary___F0lfl",
  "booking-summary-expanded": "styles-module__booking-summary-expanded___EnF0F",
  "booking-summary-container-full-screen": "styles-module__booking-summary-container-full-screen___8P11u",
  "booking-summary-content": "styles-module__booking-summary-content___VybJ7",
  "expanded-header": "styles-module__expanded-header___N5R0S",
  "remove-alert": "styles-module__remove-alert___liF7Z",
  "remove-alert-expanded": "styles-module__remove-alert-expanded___8xsGR"
};
export {
  e as booking_summary_container,
  o as booking_summary_container_expanded,
  m as default,
  n as disclaimer,
  _ as footer
};
